import React, { FC } from 'react'
import { MODAL_PREVIEW_CONTENT, MODAL_PREVIEW_TITLE } from '../../../../constants/richmenu'
import { PrimaryNoticeModal } from '../../../molecules/ModalContainer/PrimaryDialogTemplate/PrimaryNoticeDialog'

export const NoticePreviewModal = () => {
  return (
    <PrimaryNoticeModal
      header={MODAL_PREVIEW_TITLE}
      content={MODAL_PREVIEW_CONTENT}
    />
  )
}
